export interface ClientAccountFactFind {
    id?: string | null;
    date?: string | Date | null;
    hasGuardiansInsurance: boolean;
    hasLifeInsurance: boolean;
    hasLifeInsuranceInTrust: boolean;
    hasPension: boolean;
    hasFuneralPlan: boolean;
    hasForeignProperty: boolean;
    hasInvestments: boolean;
    hasEquityRelease: boolean;
    hasBusinessInterests: boolean;
    version?: number;
}

export function createClientAccountFactFind(): ClientAccountFactFind {
    return {
        hasGuardiansInsurance: false,
        hasLifeInsurance: false,
        hasLifeInsuranceInTrust: false,
        hasPension: false,
        hasFuneralPlan: false,
        hasForeignProperty: false,
        hasInvestments: false,
        hasEquityRelease: false,
        hasBusinessInterests: false,
    };
}
